import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

export const toTime = (
  timestamp: number | string | Date | Dayjs,
  isMilliseconds: boolean = false,
): Dayjs => {
  if (dayjs.isDayjs(timestamp)) {
    return timestamp;
  }

  if (typeof timestamp === 'number') {
    return isMilliseconds ? dayjs(timestamp) : dayjs.unix(timestamp);
  }

  if (typeof timestamp === 'string') {
    if (new Date(timestamp).toString() === 'Invalid Date') {
      return dayjs('Invalid Date'); // Returns an invalid Day.js object
    }

    // This is to bypass warnings by specifying the formats we are sending into Day.js
    const usedFormats = [
      'YYYY-MM-DD',
      'MMMM DD, YYYY',
      'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ',
      'YYYY-MM-DD LTS',
      'YYYY-MM-DD HH:mm',
      'YYYY-MM-DDTHH:mm:ss.SSSZ',
      'YYYY-MM-DDTHH:mm:ssZ',
      'MMMM DD, YYYY HH:mm:ss [GMT]Z',
    ];

    const date = dayjs(timestamp, usedFormats, true);
    return date.isValid() ? date : dayjs('Invalid Date');
  }

  return dayjs(timestamp);
};
